import React from "react"
import { TextProps } from "rebass"
import { TextBase } from "./headings"

export const BodyHeader1Medium = ({ children, ...props }: TextProps) => {
  return (
    <TextBase
      fontFamily="Inter500"
      fontSize="18px"
      lineHeight="22px"
      {...(props as any)}
    >
      {children}
    </TextBase>
  )
}

export const BodyHeader1Regular = ({ children, ...props }: TextProps) => {
  return (
    <TextBase
      fontFamily="Inter400"
      fontSize="18px"
      lineHeight="22px"
      letterSpacing="-0.5px"
      {...(props as any)}
    >
      {children}
    </TextBase>
  )
}

export const BodyHeader1Semibold = ({ children, ...props }: TextProps) => {
  return (
    <TextBase
      fontFamily="Inter600"
      fontSize="18px"
      lineHeight="22px"
      letterSpacing="-0.5px"
      {...(props as any)}
    >
      {children}
    </TextBase>
  )
}

export const BodyHeader2Regular = ({ children, ...props }: TextProps) => {
  return (
    <TextBase
      fontFamily="Inter400"
      fontSize="16px"
      lineHeight="19px"
      letterSpacing="-0.5px"
      {...(props as any)}
    >
      {children}
    </TextBase>
  )
}

export const BodyHeader2Semibold = ({ children, ...props }: TextProps) => {
  return (
    <TextBase
      fontFamily="Inter600"
      fontSize="16px"
      lineHeight="19px"
      letterSpacing="-0.5px"
      {...(props as any)}
    >
      {children}
    </TextBase>
  )
}
